<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>

<div class="wrapper">
  <div class="flex flex-row items-center tenant-header">
    <mat-icon svgIcon="arrow_back" class="cursor-pointer icon-lg" (click)="goToTenant()"></mat-icon>
		<div class="icon-border ml-16 p-12">
			<img src="/assets/images/combined_shape.png" class="icon-lg" alt="Instance">
		</div>
    <h2 class="m-0 fw-600">{{tenantId}}</h2>
  </div>
  <div class="flex container pt-16">
    <aside class="sidebar p-18">
      <div
        *ngFor="let item of menuItems"
        class="menu-item fs-16 fw-500 p-8"
        [class.active]="activeSection === item.id"
        (click)="scrollTo(item.id)">
        {{ item.label }}
      </div>
    </aside>

    <main #scrollContainer class="content pl-12">
      <section #sectionEl id="section1" class="page-section section1 mb-16 p-24">
        <h3 class="section-title fs-16 fw-700 mb-0 mt-0">{{'ADD_TENANT.FOUNDATION_DETAILS' | transloco}}</h3>
        <div class="flex flex-row justify-between pt-16 pb-4 gap-8">
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.REALM_NAME' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.tenantId ? tenantData?.tenantId : '--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.IT_TICKETNUMBER' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.ticketNumber ? tenantData?.ticketNumber : '--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_DETAILS.STATUS' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.status ? tenantData?.status : '--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.TENANT_OWNER' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.tenantOwner ? tenantData?.tenantOwner : '--'}}</div>
          </div>
        </div>
        <div class="flex flex-row justify-between pt-16 pb-4 gap-8">
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_DETAILS.ADMIN_CONSOLE' | transloco}}</div>
            <div class="flex flex-row fs-16 fw-400" (click)="openUrl()">
              <mat-icon svgIcon="open_in_new" class="icon-sm mr-8 mt-4"></mat-icon>
              <span>{{'TENANT_DETAILS.ADMIN_CON' | transloco}}</span>
            </div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_DETAILS.MANAGEMENT_TYPE' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.managementType ? tenantData?.managementType:'--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_DETAILS.CREATED_DATE' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.dateCreated ? dateTimeFormatService.getUtcFromat(tenantData.dateCreated) : '--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_DETAILS.UPDATED_DATE' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.dateUpdated ? dateTimeFormatService.getUtcFromat(tenantData.dateUpdated) : '--'}}</div>
          </div>
        </div>
        <div class="flex flex-row justify-between pt-16 pb-4 gap-8">
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.CUSTOMER_NAME' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.customerName ? tenantData?.customerName : '--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.CUSTOMER_NUMBER' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.customerNumber ? tenantData?.customerNumber:'--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_DETAILS.REGION' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.customerRegion ? tenantData.customerRegion : '--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.COUNTRY' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.customerCountry ? tenantData.customerCountry : '--'}}</div>
          </div>
        </div>
        <div class="flex flex-row justify-between pt-16 pb-4 gap-8">
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.CUSTOMER_MNEMONIC' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.customerMnemonic ? tenantData.customerMnemonic : '--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.CUSTOMER_SCORECARD' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.scoreCard ? tenantData?.scoreCard:'--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.CUSTOMER_SALESCHANNEL' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.salesChannel ? tenantData.salesChannel : '--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.CONTRACT_END_DATE' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.contractEndDate ? dateTimeFormatService.getUtcFromat(tenantData.contractEndDate) : '--'}}</div>
          </div>
        </div>
      </section>

      <section #sectionEl id="section2" class="page-section section2 mb-16 p-24">
        <h3 class="section-title fs-16 fw-700 mb-0 mt-0">{{'ADD_TENANT.CLOUD_REGION' | transloco}}</h3>
        <div class="flex flex-row justify-between pt-16 pb-4 gap-8">
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.CLOUD_PROVIDER' | transloco}}</div>
            <div class="fs-16 fw-400">{{(tenantData?.cloudProvider || tenantData?.targetCloud) ? (tenantData?.cloudProvider || tenantData?.targetCloud) :'--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_DETAILS.REGION' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.regionPair || tenantData?.temenosRegion ? tenantData?.regionPair || tenantData?.temenosRegion :'--' }}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.PRIMARY_REGION' | transloco}}</div>
            <div class="fs-16 fw-400">{{(tenantData?.primaryCloudRegion || tenantData?.primaryRegion) ? (tenantData?.primaryCloudRegion || tenantData?.primaryRegion) : '--'}}</div>
          </div>
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_FORM.SECONDARY_REGION' | transloco}}</div>
            <div class="fs-16 fw-400">{{tenantData?.secondaryRegion ? tenantData?.secondaryRegion : '--'}}</div>
          </div>
        </div>
      </section>

      <section #sectionEl id="section3" class="page-section section3">
        <h3 class="section-title fs-16 fw-700 mb-16 mt-0">{{'TENANT_FORM.ENVIRONMENT' | transloco}}</h3>
        <div class="border-radius">
          @if (!loadEnvData) {
          <div class="skeleton-loader-header">
            <ngx-skeleton-loader count="4" appearance="line"></ngx-skeleton-loader>
          </div>
          } @if(envData?.length) {
          <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_FORM.ENVIRONMENT' | transloco }}</th>
              <td mat-cell *matCellDef="let data" class="cursor-pointer flex flex-row pt-10 environment" (click)="openInstancePage(data)">
                <span class="tenant-id pt-2">{{data.name}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="dataZone">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_FORM.DATAZONE' | transloco }} </th>
              <td mat-cell *matCellDef="let data">
                  <span class="datazone-btn fs-14 fw-400" [ngClass]="{'nonpii': data?.dataZone === 'nonpii', 'pii' : data?.dataZone === 'pii', 'prod': data?.dataZone === 'prod'}">
                    {{data?.dataZone === DataZone.DEVELOPMENT ? ('TENANT_LIST.NON_PII_SMALL' | transloco): data?.dataZone === DataZone.SECURE ? ('TENANT_LIST.PII' | transloco) : data?.dataZone === DataZone.LIVE ? ('TENANT_LIST.LIVE' | transloco): ''}}
                  </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="deploymentClass">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_FORM.CLASS' | transloco }} </th>
              <td mat-cell *matCellDef="let data"> {{(data.deploymentClass)}} </td>
            </ng-container>
            <ng-container matColumnDef="blueprint">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_FORM.SERVICE_DEFINITION' | transloco }} </th>
              <td mat-cell *matCellDef="let data">                
                {{(data.blueprint?.name)}}
              </td>
            </ng-container>
            <ng-container matColumnDef="dateCreated">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_FORM.CREATED_ON' | transloco }} </th>
              <td mat-cell *matCellDef="let data"> {{(data.dateCreated | date: 'MMM dd yyyy, HH:mm:ss')}} </td>
            </ng-container>
            <ng-container matColumnDef="createdBy">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_FORM.CREATED_BY' | transloco }} </th>
              <td mat-cell *matCellDef="let data">
                <mat-icon svgIcon="account_circle_filled" class="icon-lg icon-style" matTooltipClass="tooltip-inner left" [matTooltip]="data?.createdBy" [matTooltipPosition]="'above'"></mat-icon>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_FORM.STATUS' | transloco }} </th>
              <td mat-cell *matCellDef="let data">
                <div class="flex flex-row justify-center items-center width-status pt-2 pr-8 pb-2 pl-8" [ngClass]="data?.status === DeployStatus.FAILED ? 'failed failed-status' : data?.status === DeployStatus.DEPLOYED ? 'dep-status' : data?.status">
                  @if (statusIcons[data?.status]) {
                    <mat-icon [svgIcon]="statusIcons[data?.status]" class="icon-sm mr-4" [ngClass]="data?.status"></mat-icon>
                  }
                  <span class="status-button" [title]="data?.status">{{ data?.status | titlecase}}</span>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          } @else if (loadEnvData) {
          <div class="flex flex-col items-center justify-center mt-30 mb-30">
            <img src="/assets/images/no-data.png">
            {{'TENANT_FORM.NO_DATA_FOUND' | transloco}}
          </div>
          }
        </div>
      </section>

      <section #sectionEl id="section4" class="page-section section4 mb-16 p-24">
        @if (featureList?.length) {
        <div class="flex flex-col">
          <div class="flex flex-row justify-between pb-4 gap-8">
            <div class="flex flex-col flex-1 text-left section-title fs-16 fw-700">{{'ADD_TENANT.FEATURES' | transloco}}</div>
            <div class="flex flex-col flex-1 text-left fs-14 fw-700">{{'TENANT_LIST.NON_PII' | transloco}}</div>
            <div class="flex flex-col flex-1 text-left fs-14 fw-700">{{'TENANT_LIST.PII' | transloco}}</div>
            <div class="flex flex-col flex-1 text-left fs-14 fw-700">{{'TENANT_LIST.PROD' | transloco | uppercase}}</div>     
          </div>
          <mat-divider class="mt-4 neutral-2 mat-divider-dashed"></mat-divider>
          <ng-container *ngFor="let feature of featureList; let last = last" class="flex flex-row pt-8 pb-14">
            <div class="flex flex-row justify-between pt-8 pb-8 gap-8">
              <div class="flex flex-col flex-1 text-left fs-16 fw-500">{{ feature.displayName }}</div>             
              @if (getZoneModifiable(feature,'nonpii') && feature.modifiable) {              
              <div class="flex flex-col flex-1 text-left fs-14 fw-700">
                @if(getZoneValue(feature,'nonpii')) {
                  <div class="green-circle w-20 h-20">
                    <mat-icon svgIcon="done" class="icon-md"></mat-icon>
                  </div>
                } @else {
                  <mat-icon svgIcon="close" class="icon-md close-icon"></mat-icon>
                }
              </div>
              }
              @if (!getZoneModifiable(feature,'nonpii') || !feature.modifiable) {
                <div class="flex flex-col flex-1 text-left fs-14 fw-700">
                  <span>-</span>
                </div>
              }
              @if (getZoneModifiable(feature,'pii') && feature.modifiable) {
              <div class="flex flex-col flex-1 text-left fs-14 fw-700">
                @if(getZoneValue(feature,'pii')) {
                  <div class="green-circle w-20 h-20">
                    <mat-icon svgIcon="done" class="icon-md"></mat-icon>
                  </div>
                } @else {
                  <mat-icon svgIcon="close" class="icon-md close-icon"></mat-icon>
                }
              </div>
              }
              @if (!getZoneModifiable(feature,'pii') || !feature.modifiable) {
                <div class="flex flex-col flex-1 text-left fs-14 fw-700">
                  <span>-</span>
                </div>
              }
              @if (getZoneModifiable(feature,'prod') && feature.modifiable) {
              <div class="flex flex-col flex-1 text-left fs-14 fw-700">
                @if(getZoneValue(feature,'prod')) {
                <div class="green-circle w-20 h-20">
                  <mat-icon svgIcon="done" class="icon-md"></mat-icon>
                </div>
                } @else {
                <mat-icon svgIcon="close" class="icon-md close-icon"></mat-icon>
                }
              </div>
              }
              @if (!getZoneModifiable(feature,'prod') || !feature.modifiable) {
              <div class="flex flex-col flex-1 text-left fs-14 fw-700">
                <span>-</span>
              </div>
              }
              
            </div>
            @if (!last) {
            <mat-divider class="mb-4 mt-4 neutral-2 mat-divider-dashed"></mat-divider>
            }
          </ng-container>
        </div>
        } @else {
        <h3 class="section-title fs-16 fw-700 mb-16 mt-0">{{'ADD_TENANT.FEATURES' | transloco}}</h3>
        <div class="flex flex-col items-center justify-center mt-30 mb-30">
          <img src="/assets/images/no-data.png">
          {{'TENANT_FORM.NO_DATA_FOUND' | transloco}}
        </div>
        }
      </section>

      <section #sectionEl id="section5" class="page-section section5 mb-16 p-24">
        <h3 class="section-title fs-16 fw-700 mb-0 mt-0">{{'ADD_TENANT.SETTINGS' | transloco}}</h3>
        @if (notificationEmails){
        <div class="flex flex-row justify-between pt-16 pb-4 gap-8">
          <div class="flex flex-col flex-1 text-left">
            <div class="fs-14 fw-700 mb-4">{{'TENANT_LIST.ADD_EMAIL_ADDRESS' | transloco}}</div>
            <div class="fs-16 fw-400">{{notificationEmails}}</div>
          </div>
        </div>
         } @else {
        <div class="flex flex-col items-center justify-center mt-30 mb-30">
          <img src="/assets/images/no-data.png">
          {{'TENANT_FORM.NO_DATA_FOUND' | transloco}}
        </div>
        }
      </section>
    </main>

  </div>
</div>